module.exports = __webpack_public_path__ + "img/close-icon.d6864a84.svg";